<div class="progress-spinner d-flex align-items-center d-flex justify-content-center" *ngIf="true">
<div>
    <!-- <img src="../../../assets/media/msis/loading1.gif" style="width: 50%;margin: 0 auto;margin-bottom: 0.5em;display: block; background: #037fff;border-radius: 50%;"> -->
   <p-progressSpinner [style]="{width: '100px', height: '100px'}" styleClass="custom-spinner"   ></p-progressSpinner>
</div>



</div>
